// extracted by mini-css-extract-plugin
export default {"validatePanelFooter":"validatePanelFooter-hh6ru","caption":"caption-XSryj","button":"button-I2xlz"};